import React from 'react'

const Header = () => {
  return (
    <div className=' w-screen border shadow-md py-4 fixed top-0 bg-white'>
      <h1 className='uppercase text-3xl font-bold text-center'>Blog Posts</h1>
      
    </div>
  )
}

export default Header
